export { pushAdClickData } from 'next-flight-server-reference-proxy-loader?id=70c98b2c847e577e2b7de94e685d9bf55ca8c41f7d&name=pushAdClickData!'